@if (product) {
  <p-tag
    (click)="toggleSelect()"
    [styleClass]="
      isSelected
        ? 'cursor-pointer border-2 border-green-600'
        : 'cursor-pointer border-2 border-transparent'
    "
    [value]="product.name"
  />
}
